import React from 'react'
import { Link } from 'react-router-dom'
import {BackToTop, CustomerSupport} from '../'
import { FacebookOutlined, GitHub, Instagram, LinkedIn, X } from '@mui/icons-material'
import './footer.css'

const Footer = () => {
  return (
    <>
      <footer className="footer-container">
        <div className="footer-main">
          <span className="footer-text">© { new Date().getFullYear() } Oluwasanmi Hub || All Rights Reserved.
          </span>
          <div className="footer-link-icons">
            <Link to="https://facebook.com/sanmexm" target="_blank" className="link-icons-bottom">
              <FacebookOutlined />
            </Link>
            <Link to="https://instagram.com/sanmexm" target="_blank" className="link-icons-bottom">
              <Instagram />
            </Link>
            <Link to="https://x.com/sanmexm" target="_blank" className="link-icons-bottom">
              <X />
            </Link>
            <Link to="https://www.linkedin.com/in/manuwa-oluwasanmi-327a0898/" target="_blank" className="link-icons-bottom">
              <LinkedIn />
            </Link>
            <Link to="https://github.com/sanmexm" target="_blank" className="link-icons-bottom">
              <GitHub />
            </Link>
          </div>
        </div>
      </footer>
      <CustomerSupport />
      <BackToTop />
    </>
  )
}

export default Footer